import Button from "@/common/elements/Button";
import TabsV2 from "@/common/elements/TabsV2";
import {
  ActionHeader,
  InmateDetailsContainer,
  PageTabsWrapper,
  StyledActionControlContainer,
} from "@/common/styles";
import Personal, { PERSON } from "@/components/InmateDetails/Personal";

import { useEffect, useImperativeHandle, useMemo, useState } from "react";
import { CreateStaffingContainer, StyleadInnerHeader } from "./styles";
import AssignmentLog from "./tabs/AssignmentLog";
import Equipments from "./tabs/Equipments.jsx";
import GroupsSecurityRules from "./tabs/GroupsSecurityRules.jsx";
import LoginInfo from "./tabs/LoginInfo";
import MedicalInfo from "./tabs/MedicalInfo";
import SkillsCertifications from "./tabs/SkillsCertifications.jsx";
import Supplementals from "./tabs/Supplementals.jsx";
import PersonalInformationDetails from "@/components/BookingsDetails/PersonalInformationDetails";
import Docs from "@/components/InmateDetails/Docs";
import SupplementalDetails from "@/components/BookingsDetails/OfficerReports/SupplementalDetails";
import StaffAdministrativeInformation from "../Users/sections/StaffAdministrativeInformation";
import StaffPoliceCentralUserInfo from "./tabs/StaffPoliceCentralUserInfo";
import TrainingClassDetails from "./tabs/TrainingClassDetails";
import OrganizationalRank from "./tabs/OrganizationalRank";
import { MODULES_LIST } from "@/util/common_variable";

export const MODE = { NEW: "new", EDIT: "edit" };

const CreateStaffing = ({
  allFormRef,
  onNextClickTrigger,
  nextBtnRef,
  tabChangeRef,
  module = MODULES_LIST.STAFFING,
}) => {
  const [currentTabKey, setCurrentTabKey] = useState(null);
  const [sectionItems, setSectionItems] = useState([
    {
      id: 1,
      key: "personal-information",
      label: "Personal Information",
      children: (
        <PersonalInformationDetails
          allFormRef={allFormRef}
          isStaff={true}
          detailLevel={PERSON.STAFF}
        />
      ),
    },
    {
      id: 3,
      key: "medical",
      label: "Medical Information",
      children: <MedicalInfo />,
    },
    {
      id: 4,
      key: "assignment",
      label: "Assignment/Activity Log",
      children: <AssignmentLog />,
    },
    {
      id: 5,
      key: "organizational",
      label: "Organizational Rank",
      children: (
        <OrganizationalRank
          organizationRankRef={allFormRef?.organizationRankRef}
        />
      ),
    },
    {
      id: 6,
      key: "skills",
      label: "Skills/Certifications",
      children: <SkillsCertifications />,
    },
    {
      id: 7,
      key: "training",
      label: "Training",
      children: <TrainingClassDetails />,
    },
    {
      id: 8,
      key: "equipments",
      label: "Assigned Equipment",
      children: <Equipments />,
    },
    {
      id: 9,
      key: "linked-scanned-documents",
      label: "Linked and Scanned Documents",
      children: <Docs parentKey={MODULES_LIST.STAFF} />,
    },
    {
      id: 10,
      key: "supplementals",
      label: "Staff Supplementals",
      children: <SupplementalDetails showAgencyInfo={true} />,
    },
    {
      id: 12,
      key: "police-central-userinfo",
      label: "Login information",
      children: (
        <StaffPoliceCentralUserInfo
          policeCentralUserRef={allFormRef?.policeCentralUserRef}
        />
      ),
    },
    {
      id: 13,
      key: "staff-administrative-information",
      label: "Staff Administrative Information",
      children: <StaffAdministrativeInformation />,
    },
  ]);

  useImperativeHandle(tabChangeRef, () => ({
    onTabChange: onTabChange,
  }));

  const onTabChange = (value) => {
    setCurrentTabKey(value);
  };

  useEffect(() => {
    if (module === MODULES_LIST.USERS) {
      setSectionItems(() => [
        {
          id: 1,
          key: "personal-information",
          label: "Personal Information",
          children: (
            <PersonalInformationDetails
              allFormRef={allFormRef}
              isStaff={true}
              detailLevel={PERSON.LOW}
            />
          ),
        },
        {
          id: 5,
          key: "organizational",
          label: "Organizational Rank",
          children: (
            <OrganizationalRank
              organizationRankRef={allFormRef?.organizationRankRef}
            />
          ),
        },
        {
          id: 12,
          key: "police-central-userinfo",
          label: "Login information",
          children: (
            <StaffPoliceCentralUserInfo
              policeCentralUserRef={allFormRef?.policeCentralUserRef}
            />
          ),
        },
        {
          id: 13,
          key: "staff-administrative-information",
          label: "Staff Administrative Information",
          children: <StaffAdministrativeInformation />,
        },
      ]);
    }
    return () => {
      sessionStorage.removeItem("from-jacket");
    };
  }, []);

  return (
    <CreateStaffingContainer>
      <InmateDetailsContainer>
        <PageTabsWrapper style={{ height: "100%" }}>
          <TabsV2
            navButtonsColor="default"
            items={sectionItems}
            activeKey={currentTabKey}
            onChange={onTabChange}
            nextBtnRef={nextBtnRef}
            onNextClickTrigger={onNextClickTrigger}
          />
        </PageTabsWrapper>
      </InmateDetailsContainer>
    </CreateStaffingContainer>
  );
};

export default CreateStaffing;
